import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

import {
    EditQuoteTermState,
    QuoteTermData,
    QuoteTermsState,
    QuoteTermState,
} from "@tKgpco/Store/Data/Terms/TermsState";

const initialState: QuoteTermsState = {
    isLoading: false,
    isLoadingOverlay: false,
    quoteTerms: null,
    activeQuoteTerms: null,
    selectedTermIds: {},
    selectFilter: "",
    selectFilterText: "",
    pagination: null,
    isAllTermSelected: false,
    selectedSalesTermIds: [],
    quoteCode: "",
};
type SearchFilterKeys = "selectFilter" | "selectFilterText";
type SearchFilterActionType = {
    key: SearchFilterKeys;
    value: string;
};
export const reducer = {
    "Custom/Terms/BeginLoad": (draft: Draft<QuoteTermsState>) => {
        draft.isLoading = true;
    },
    "Custom/Terms/ShowOverlay": (draft: Draft<QuoteTermsState>) => {
        draft.isLoadingOverlay = true;
    },
    "Custom/Terms/HideOverlay": (draft: Draft<QuoteTermsState>) => {
        draft.isLoadingOverlay = false;
    },
    "Custom/Terms/CompleteLoad": (draft: Draft<QuoteTermsState>, action: QuoteTermState) => {
        draft.isLoading = false;
        draft.activeQuoteTerms = action.quoteTerms.quoteTerms?.filter(quote => quote.isActive) || [];
        draft.quoteTerms = action.quoteTerms.quoteTerms;
        draft.pagination = action.quoteTerms.pagination;
    },
    "Custom/Terms/FailedToLoadTerms": (draft: Draft<QuoteTermsState>) => {
        draft.isLoading = false;
        draft.quoteTerms = null;
        draft.activeQuoteTerms = null;
    },
    "Custom/Terms/ToggleSelectedTerms": (draft: Draft<QuoteTermsState>, action: { ids: string[] }) => {
        for (const id of action.ids) {
            if (draft.selectedTermIds[id]) {
                delete draft.selectedTermIds[id];
            } else {
                draft.selectedTermIds[id] = true;
            }
        }
    },
    "Custom/Terms/ClearSelectedTerms": (draft: Draft<QuoteTermsState>) => {
        draft.selectedTermIds = {};
    },
    "Custom/Terms/SetSearchFilter": (
        draft: Draft<QuoteTermsState>,
        { filters }: { filters: SearchFilterActionType },
    ) => {
        draft[filters.key] = filters.value;
    },
    "Custom/Terms/SelectedAllTerms": (draft: Draft<QuoteTermsState>, action: { isAllTermSelected: boolean }) => {
        draft.isAllTermSelected = action.isAllTermSelected;
    },
    "Custom/Terms/SelectedTermIdsForSales": (
        draft: Draft<QuoteTermsState>,
        action: { selectedSalesTermIds: string[] },
    ) => {
        draft.selectedSalesTermIds = action.selectedSalesTermIds;
    },
    "Custom/GetTermCode/CompleteLoad": (draft: Draft<any>, action: { quoteCode: string }) => {
        draft.quoteCode = action.quoteCode;
    },
};
export default createTypedReducerWithImmer(initialState, reducer);
